import { render, staticRenderFns } from "./LibBtnSimple.vue?vue&type=template&id=562fae27&scoped=true"
import script from "./LibBtnSimple.vue?vue&type=script&lang=js"
export * from "./LibBtnSimple.vue?vue&type=script&lang=js"
import style0 from "./LibBtnSimple.vue?vue&type=style&index=0&id=562fae27&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562fae27",
  null
  
)

export default component.exports